/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Formik } from 'formik';
import { FC, useState } from 'react';
import * as yup from 'yup';
import { useFormContext } from '../../../../../contexts/FormContext';
import {
  InputLength,
  SocialPlatform,
  FormType,
  OutputQuantity,
  PersonaSocialInput,
} from '../../../../../types/FormTypes';
import { ListenToFormikValues } from '../../../../shared/formik/ListenToFormikValues';
import { GenerateResponseButtons } from '../GenerateResponseButtons';
import formStyles from '../formStyles.module.css';
import { usePersonaContext } from '../../../../../contexts/PersonaContext';
import axios from 'axios';
import { AdvancedInputs } from '../formInputs/AdvancedInputs';
import { ToggleInput } from '../../../../shared/inputs/ToggleInput';
import { useRouter } from 'next/router';
import React from 'react';
import Image from 'next/image';
import styled from '@emotion/styled';
import { useEffect } from 'react';
import styles from './PersonaSocialStyle.module.css';
import { BoxedAutoResizeTextarea } from '../../../../shared/inputs/BoxedAutoResizeTextarea';
import { BasicPopup } from '../../../../shared/popups/BasicPopup';
import { ProductPersonaSoloPopup } from '../../../personasPage/productPersonaPopup';
import { BrandPersonaSoloPopup } from '../../../personasPage/BrandPersonaPopupSolo';
import { AudiencePersonaSoloPopup } from '../../../personasPage/AudiencePersonaPopup';
import { BasicButton } from '../../../../shared/buttons/BasicButton';
import { SmallerSimpleBadge } from '../../../../shared/badge/SmallerSimpleBadge';
import { EditAudiencePersonaPopup } from '../../../personasPage/EditAudiencePersonaPopup';
import { EditBrandPersonaPopup } from '../../../personasPage/EditBrandPersonaPopup';
import { EditProductPersonaPopup } from '../../../personasPage/EditProductPersonaPopup';
import { useAuthContext } from '../../../../../contexts/AuthContext';
import { BrandPersona, ProductPersona, AudiencePersona } from '../../../../../types/Persona.type';

const DropDownContainer = styled('div')`
  width: 100%;
  cursor: pointer;
  font-family: "Poppins", sans-serif;
  position: relative;
  display: flex;
  z-index: 0;
  flex-direction: column;
  padding: 0em 0.3em 0em 0em;
`;

const DropDownContainer2 = styled('div')`
  width: 100%;
  cursor: pointer;
  position: relative;
  display: flex;
  z-index: 3;
  flex-direction: column;
  padding: 0em 0.3em 0em 0em;
`;

const DropDownContainer3 = styled('div')`
  width: 100%;
  cursor: pointer;
  position: relative;
  display: flex;
  z-index: 2;
  flex-direction: column;
  padding: 0em 0.3em 0em 0em;
`;

const DropDownIcon = styled('div')`
  position: sticky;
  left: 100%;
  display: flex;
  z-index: 4;
  flex-direction: column;
`;

const DropDownIcon2 = styled('div')`
  position: sticky;
  left: 100%;
  display: flex;
  z-index: 3;
  flex-direction: column;
`;

const DropDownIcon3 = styled('div')`
  position: sticky;
  left: 100%;
  display: flex;
  z-index: 2;
  flex-direction: column;
`;

const DropDownHeader = styled('div')`
  width: 100%;
  cursor: pointer;
  margin-bottom: 0.4em;
  padding: 0.5em 0.5em 0.5em 0.5em;
  font-weight: 400;
  font-size: 1rem;
  color: black;
  font-family: "Poppins", sans-serif;
  background: white;
  border: 1px solid black;
  border-radius: 4px;
  display: flex;
`;

const DropDownListContainer = styled('div')`
  width: 100%;
  cursor: pointer;
  font-weight: 500;
  font-size: 1.3rem;
  font-family: "Poppins", sans-serif;
  color: #3faffa;
  background: white;
  border: 1.83px solid black;
  border-radius: 2px;
  width: 100%;
  z-index: 0;
`;

const DropDownList = styled('ul')`
  width: 100%;
  cursor: pointer;
  padding: 0;
  margin: 0;
  z-index: 0;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 2px;
  color: black;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  &:first-of-type {
    padding-top: 0em;
  }
`;

const ListItem = styled('li')`
  width: 100%;
  cursor: pointer;
  list-style: none;
  padding-bottom: 0.6em;
  padding-top: 0.6em;
  padding-left: 1em;
  border-bottom: 1px solid black;
  font-family: "Poppins", sans-serif;
  display: flex;
  z-index: 500;

  justify-content: space-between;
  align-items: center;
  &: last-of-type {
    border-bottom: 0px;
  }

  &:hover {
    color: #4690ff;
    background-color: #dadada;
  }
`;

const ListItem2 = styled('li')`
  width: 100%;
  cursor: pointer;
  list-style: none;
  padding-bottom: 0.8em;
  padding-top: 0.8em;
  padding-left: 1em;
  border-bottom: 1px solid black;
  color: gray;
  display: flex;
  font-family: "Poppins", sans-serif;
  align-items: center;

  &:hover {
    color: #4690ff;
    background-color: #dadada;
  }
`;

const ListItem3 = styled('li')`
  width: 100%;
  list-style: none;
  padding-bottom: 0.8em;
  padding-top: 0.8em;
  padding-left: 1em;
  border-bottom: 1px solid black;
  color: black;
  display: flex;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-size: 0.9rem;
  align-items: center;

  &:hover {
    color: #4690ff;
    background-color: #dadada;
  }
`;

const Innertext = styled('div')`
  padding-top: 0.4em;
  padding-left: 0.5em;
`;

const Innertext2 = styled('div')`
  padding-top: 0.5em;
  padding-left: 0.5em;
  padding-bottom: 0.5em;
`;

const ButtonListContainer = styled('div')`
  width: 6.1vw;
  font-weight: 500;
  font-size: 1.3rem;
  font-family: "Poppins", sans-serif;
  color: #3faffa;
  background: white;
  position: absolute;
  border: 1.2px solid black;
  border-radius: 2px;
  z-index: 30;
`;

const ButtonList = styled('ul')`
  width: 6vw;
  padding: 0;
  margin: 0;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 2px;
  color: black;
  font-size: 0.9rem;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
  &:first-of-type {
    padding-top: 0em;
  }
`;

const ButtonItem = styled('li')`
  width: 6vw;
  list-style: none;
  border-bottom: 1px solid black;
  font-family: "Poppins", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  &: last-of-type {
    border-bottom: 0px;
  }

  &:hover {
    color: #4690ff;
    background-color: #dadada;
  }
`;

const EGInputsSchema = yup.object<
  Partial<Record<keyof PersonaSocialInput, yup.AnySchema>>
>({
  platform: yup
    .mixed<SocialPlatform>()
    .oneOf(Object.values(SocialPlatform))
    .required('Please select platform'),

  // intent: yup
  //   .string()
  //   .required('Please enter the intent of your social post')
  //   .min(5, 'Intent is too vague! Consider adding more details'),

  toneDegree: yup.object(),

  length: yup
    .mixed<InputLength>()
    .oneOf(Object.values(InputLength))
    .required('Please select a length for your social post'),
  multipleOutputs: yup
    .mixed<OutputQuantity>()
    .oneOf(Object.values(OutputQuantity))
    .required(),
});

export const PersonaSocialForm: FC = () => {
  const {
    personaSocialInput,
    setPersonaSocialInput,
    submitContentForm,
    setCanKeepGoing,
    loading,
  } = useFormContext();
  const router = useRouter();
  const {
    brandPersonas,
    audiencePersonas,
    productPersonas,
    deleteBrand,
    deleteProduct,
    deleteAudience,
    currentAudPersona,
    currentBrandPersona,
    currentProductPersona,
    saveCurrentPersonas,
  } = usePersonaContext();
  const { userData, logRecentPersonaData } = useAuthContext();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [selectedOption, setSelectedOption] = useState(
    currentBrandPersona?.brand ?? 'Please Select a Brand'
  );
  const [selectedBrand, setSelectedBrand] = useState('');
  const [picture, setPicture] = useState(currentBrandPersona?.profilePic ?? '');
  const [picture2, setPicture2] = useState(currentAudPersona?.profilePic ?? '');
  const [platformSelection, setSelectedPlatform] = useState('');
  const [socialPicture, setSocialPicture] = useState('');
  const [socialName, setSocialName] = useState('');
  const [selectedAudOption, setSelectedAudOption] = useState(
    currentAudPersona?.audience ?? 'Please Select an Audience'
  );
  const [selectedAudience, setAudienceList] = useState('');
  const [selectedProOption, setSelectedProOption] = useState('(Optional)');
  const [selectedProduct, setProductList] = useState('');
  const toggling = () => setIsOpen(!isOpen);
  const toggling2 = () => {
    if (B1 === '') {
      setShouldJiggle(true);
      setTimeout(() => {
        setShouldJiggle(false);
      }, 500); // 500ms is the duration of your jiggle animation
    } else {
      setIsOpen2(!isOpen2);
    }
  };
  const toggling3 = () => {
    if (B1 === '') {
      setShouldJiggle(true);
      setTimeout(() => {
        setShouldJiggle(false);
      }, 500); // 500ms is the duration of your jiggle animation
    } else {
      setIsOpen3(!isOpen3);
    }
  };
  const toggling4 = () => setIsOpen4(!isOpen4);
  const [showBrandPopup, setShowBrandPopup] = useState(false);
  const [showAudiencePopup, setShowAudiencePopup] = useState(false);
  const [showProductPopup, setShowProductPopup] = useState(false);
  const [showEditPopup, setEditPopup] = useState(false);
  const [showDeletePopup, setDeletePopup] = useState(false);
  const [showProEditPopup, setProEditPopup] = useState(false);
  const [showProDeletePopup, setProDeletePopup] = useState(false);
  const [showAudEditPopup, setAudEditPopup] = useState(false);
  const [showAudDeletePopup, setAudDeletePopup] = useState(false);

  const [B1, setB1] = useState(currentBrandPersona?.brand ?? ''); //brand
  const [B2, setB2] = useState(currentBrandPersona?.description ?? ''); //brandDescription
  const [B3, setB3] = useState(currentBrandPersona?.website ?? ''); //website
  const [B4, setB4] = useState(currentBrandPersona?.tone ?? ['']); // tone
  const [B5, setB5] = useState(currentBrandPersona?.industry ?? ''); // industry
  const [B6, setB6] = useState(currentBrandPersona?.brandPositioning ?? ''); // brandPositioning
  const [B7, setB7] = useState(currentBrandPersona?.brandNoNoWords ?? ['']); // brandAvoid
  const [B8, setB8] = useState(
    currentBrandPersona?.brandReplacementWords ?? [
      { replaceThis: '', withThis: '' },
    ]
  ); // brandReplacementing
  const [B9, setB9] = useState(
    currentBrandPersona?.brandUseSparinglyWords ?? ['']
  ); // brandSparingly
  const [A0, setA0] = useState(currentAudPersona?.audience ?? ''); //audience
  const [A1, setA1] = useState(currentAudPersona?.painpoints ?? ''); //painpoint
  const [A2, setA2] = useState(currentAudPersona?.location ?? ['']); //location
  const [A3, setA3] = useState(currentAudPersona?.occupation ?? ['']); //occupation
  const [A4, setA4] = useState(currentAudPersona?.age ?? ['']); //age
  const [A5, setA5] = useState(currentAudPersona?.goals ?? ''); //goals
  const [A6, setA6] = useState(currentAudPersona?.barriers ?? ''); //barriers
  const [A7, setA7] = useState(currentAudPersona?.triggers ?? ''); //triggers
  const [A8, setA8] = useState(currentAudPersona?.profilePic ?? ''); //ProfilePic
  const [P1, setP1] = useState(''); //product
  const [P2, setP2] = useState(''); // productdescription

  const [v1, setv1] = useState('');
  const [id, setv2] = useState('');
  const [v3, setv3] = useState('');
  const [v4, setv4] = useState(['']);
  const [v5, setv5] = useState('');
  const [v6, setv6] = useState('');
  const [v7, setv7] = useState('');
  const [v8, setv8] = useState('');
  const [v9, setv9] = useState(['']);
  const [v10, setv10] = useState([{ replaceThis: '', withThis: '' }]);
  const [v11, setv11] = useState(['']);
  const [p1, setp1] = useState('');
  const [p2, setp2] = useState('');
  const [p3, setp3] = useState('');
  const [p4, setp4] = useState({ value: '', label: '' });
  const [a1, seta1] = useState('');
  const [a2, seta2] = useState({ value: '', label: '' });
  const [a3, seta3] = useState(['']);
  const [a4, seta4] = useState(['']);
  const [a5, seta5] = useState(['']);
  const [a6, seta6] = useState(['']);
  const [a7, seta7] = useState('');
  const [a8, seta8] = useState('');
  const [a9, seta9] = useState('');
  const [a10, seta10] = useState('');
  const [a11, seta11] = useState('');
  const [a12, seta12] = useState('');

  const onOptionClicked =
    (
      value: React.SetStateAction<string>,
      value2: React.SetStateAction<string>,
      value3: React.SetStateAction<string>,
      value4: React.SetStateAction<string[]>,
      value5: React.SetStateAction<string>,
      value6: React.SetStateAction<string>,
      value7: React.SetStateAction<string>,
      value8: React.SetStateAction<string[]>,
      value9: React.SetStateAction<{ replaceThis: string; withThis: string }[]>,
      value10: React.SetStateAction<string[]>,
      entireBrand: React.SetStateAction<BrandPersona>,
    ) =>
      () => {
        setSelectedOption(value);
        setB1(value);
        setB2(value2);
        setB3(value3);
        setB4(value4);
        setB5(value5);
        setB6(value7);
        setB7(value8);
        setB8(value9);
        setB9(value10);
        saveCurrentPersonas(
                      {} as ProductPersona,
                      {} as AudiencePersona,
                      entireBrand as BrandPersona
                    );
        setPicture(value6);
        setIsOpen(false);
      };

  const onAudOptionClicked =
    (
      value: React.SetStateAction<string>,
      value2: React.SetStateAction<string>,
      value3: React.SetStateAction<string[]>,
      value4: React.SetStateAction<string[]>,
      value5: React.SetStateAction<string[]>,
      value6: React.SetStateAction<string>,
      value7: React.SetStateAction<string>,
      value8: React.SetStateAction<string>,
      v9: React.SetStateAction<string>,
      entireAud: React.SetStateAction<AudiencePersona>,
    ) =>
      () => {
        setSelectedAudOption(value);
        setA0(value);
        setA1(value2);
        setA2(value3);
        setA3(value4);
        setA4(value5);
        setA5(value6);
        setA6(value7);
        setA7(value8);
        setA8(v9);
        saveCurrentPersonas(
                  {} as ProductPersona,
                  entireAud as AudiencePersona,
                );
        setPicture2(v9);
        setIsOpen2(false);
      };

  useEffect(() => {
    // console.log('this is option selected:', selectedOption);
    // console.log('this is brand selected:', selectedBrand);
    // console.log('this is image selected:', picture);
  }, [selectedOption, selectedBrand, picture]);

  const onProOptionClicked =
    (
      value: React.SetStateAction<string>,
      value2: React.SetStateAction<string>
    ) =>
      () => {
        setSelectedProOption(value);
        setP1(value);
        setP2(value2);
        setIsOpen3(false);
      };

  const onSocialOptionClicked =
    (
      value: React.SetStateAction<string>,
      value2: React.SetStateAction<string>,
      value3: React.SetStateAction<string>
    ) =>
      () => {
        setSelectedPlatform(value);
        setSocialPicture(value2);
        setSocialName(value3);
        setIsOpen4(false);
        // console.log(socialPicture);
      };

  const BrandEditClick =
    (
      v1: React.SetStateAction<string>,
      v2: React.SetStateAction<string>,
      v3: React.SetStateAction<string>,
      v4: React.SetStateAction<string[]>,
      v5: React.SetStateAction<string>,
      v6: React.SetStateAction<string>,
      v7: React.SetStateAction<string>,
      value8: React.SetStateAction<string>,
      v9: React.SetStateAction<string[]>,
      v10: React.SetStateAction<{ replaceThis: string; withThis: string }[]>,
      v11: React.SetStateAction<string[]>
    ) =>
      () => {
        setv1(v1);
        setv2(v2);
        setv3(v3);
        setv4(v4);
        setv5(v5);
        setv6(v6);
        setv7(v7);
        setv8(value8);
        setv9(v9);
        setv10(v10);
        setv11(v11);
      };

  const BrandDeleteClick =
    (
      v1: React.SetStateAction<string>,
      v2: React.SetStateAction<string>,
      v3: React.SetStateAction<string>,
      v4: React.SetStateAction<string[]>,
      v5: React.SetStateAction<string>,
      v6: React.SetStateAction<string>,
      v7: React.SetStateAction<string>,
      v8: React.SetStateAction<string>
    ) =>
      () => {
        setv1(v1);
        setv2(v2);
        setv3(v3);
        setv4(v4);
        setv5(v5);
        setv6(v6);
        setv7(v7);
        setv8(v8);
        toggling;
        setDeletePopup(true);
      };

  const ProductEditClick =
    (
      p1: React.SetStateAction<string>,
      p2: React.SetStateAction<string>,
      p3: React.SetStateAction<string>,
      p4: React.SetStateAction<{ value: string; label: string }>
    ) =>
      () => {
        setp1(p1); //product
        setp2(p2); // description
        setp3(p3); //id
        setp4(p4); //brand
        toggling3;
        setProEditPopup(true);
      };

  const ProductDeleteClick =
    (
      p1: React.SetStateAction<string>,
      p2: React.SetStateAction<string>,
      p3: React.SetStateAction<string>,
      p4: React.SetStateAction<{ value: string; label: string }>
    ) =>
      () => {
        setp1(p1); //product
        setp2(p2); // description
        setp3(p3); //id
        setp4(p4); //brand
        toggling3;
        setProDeletePopup(true);
      };

  const AudienceEditClick =
    (
      a1: React.SetStateAction<string>,
      a2: React.SetStateAction<{ value: string; label: string }>,
      a3: React.SetStateAction<string[]>,
      a4: React.SetStateAction<string[]>,
      a5: React.SetStateAction<string[]>,
      a6: React.SetStateAction<string[]>,
      a7: React.SetStateAction<string>,
      a8: React.SetStateAction<string>,
      a9: React.SetStateAction<string>,
      a10: React.SetStateAction<string>,
      a11: React.SetStateAction<string>,
      a12: React.SetStateAction<string>
    ) =>
      () => {
        seta1(a1); //audience
        seta2(a2); // brand
        seta3(a3); //gender
        seta4(a4); //age
        seta5(a5); //occupation
        seta6(a6); //location
        seta7(a7); //painpoint
        seta8(a8); //id
        seta9(a9); //goals
        seta10(a10); //barriers
        seta11(a11); //triggers
        seta12(a12); //pp
        toggling2;
        setAudEditPopup(true);
      };

  const AudienceDeleteClick =
    (
      a1: React.SetStateAction<string>,
      a2: React.SetStateAction<{ value: string; label: string }>,
      a3: React.SetStateAction<string[]>,
      a4: React.SetStateAction<string[]>,
      a5: React.SetStateAction<string[]>,
      a6: React.SetStateAction<string[]>,
      a7: React.SetStateAction<string>,
      a8: React.SetStateAction<string>,
      a9: React.SetStateAction<string>,
      a10: React.SetStateAction<string>,
      a11: React.SetStateAction<string>,
      a12: React.SetStateAction<string>
    ) =>
      () => {
        seta1(a1); //audience
        seta2(a2); // brand
        seta3(a3); //gender
        seta4(a4); //age
        seta5(a5); //occupation
        seta6(a6); //location
        seta7(a7); //painpoint
        seta8(a8); //id
        seta9(a9); //goals
        seta10(a10); //barriers
        seta11(a11); //triggers
        seta12(a12); //pp
        toggling2;
        setAudDeletePopup(true);
      };

  const brandSelectedContent = audiencePersonas?.filter(
    (campaign) => campaign.brand.label === B1
  );

  const [shouldJiggle, setShouldJiggle] = useState<boolean>(false);

  const closeBrand = () => {
    // Handle the close event here
    setShowBrandPopup(false);
  };

  const closeEditBrand = () => {
    setEditPopup(false);
  };

  const closeProduct = () => {
    // Handle the close event here
    setShowProductPopup(false);
  };

  const closeEditProduct = () => {
    setProEditPopup(false);
  };

  const closeAudience = () => {
    // Handle the close event here
    setShowAudiencePopup(false);
  };

  const closeEditAudience = () => {
    setAudEditPopup(false);
  };

  // Inputs may need to be prefilled
  if (!personaSocialInput) return null;

  return (
    <Formik
      initialValues={personaSocialInput}
      onSubmit={async (values, actions) => {
        // const res = await axios.post('/api/personas/retrieveSingleBrand', selectedBrand);
        // console.log({selectedBrand})
        // console.log({selectedAudience})
        // console.log({selectedProduct})
        // console.log({res})
        // const brandSolo = res.data;
        // const brandFinal = brandSolo[0];
        // console.log({brandSolo})
        // const aud = await axios.post('/api/personas/retrieveSingleAudience', selectedAudience);
        // const audienceSolo = aud.data;
        // const audFinal = audienceSolo[0];
        // console.log({aud})
        // console.log({audienceSolo})
        // console.log({audFinal})
        // if (A1 !== '') {
        //   ''
        // } else {
        //   const pro = await axios.post('/api/personas/retrieveSingleProduct', selectedProduct);
        //   const productSolo = pro.data;
        //   const productFinal = productSolo[0];
        //   console.log({pro})
        //   console.log({productSolo})
        //   values.product= productFinal.product;
        //   values.productDescription= productFinal.description;
        // }
        if (P1 === '') {
          ('');
        } else {
          // const pro = await axios.post('/api/personas/retrieveSingleProduct', selectedProduct);
          // const productSolo = pro.data;
          // const productFinal = productSolo[0];
          // console.log({pro})
          // console.log({productSolo})
          values.product = P1;
          values.productDescription = P2;
        }
        // values.brand = brandFinal.brand;
        // const platformSelected = platformSelection as SocialPlatform;
        // // const personaInputs = {
        // values.platform= platformSelected;
        // // brand= brandFinal.brand;
        // values.brandDescription= brandFinal.description;
        // values.website= brandFinal.website;
        // values.tone= brandFinal.tone;
        // // values.intent= values.intent;
        // // values.toneDegree= values.toneDegree;
        // values.industry= brandFinal.industry;
        // values.painpoint= audFinal.painpoints;
        // values.location= audFinal.location;
        // values.occupation= audFinal.occupation;
        // values.age= audFinal.age;
        await logRecentPersonaData({
          RecentBrand: B1,
          RecentProfilePic: picture,
          RecentDescription: B2,
          RecentWebsite: B3,
          RecentTone: B4,
          RecentIndustry: B5,
          RecentBrandAvoidArray: B7,
          RecentBrandReplacementArray: B8,
          RecentBrandSparinglyArray: B9,
          RecentAudience: A0,
          RecentAudienceProfilePic: picture2,
          RecentPainpoints: A1,
          RecentLocation: A2,
          RecentOccupation: A3,
          RecentAge: A4,
          RecentAudienceGoals: A5,
          RecentAudienceTriggers: A7,
          RecentAudienceBarriers: A6,
          RecentProduct: P1,
          RecentProductDescription: P2,
        });

        values.brand = B1;
        values.brandAvoidArray = B7;
        values.brandReplacementArray = B8;
        values.brandSparinglyArray = B9;
        const platformSelected = platformSelection as SocialPlatform;
        // const personaInputs = {
        values.platform = platformSelected;
        // brand= brandFinal.brand;
        values.brandDescription = B2;
        values.website = B3;
        values.tone = B4;
        // values.intent= values.intent;
        // values.toneDegree= values.toneDegree;
        values.industry = B5;
        values.audience = A0;
        values.painpoint = A1;
        values.location = A2;
        values.occupation = A3;
        values.age = A4;
        values.goals = A5;
        values.barriers = A6;
        values.triggers = A7;

        // setPersonaSocialInput(personaInputs as PersonaSocialInput);
        console.log('new variables done');
        //  console.log({personaInputs})
        console.log({ values });

        await submitContentForm({
          values,
          actions,
          formType: FormType.PERSONA,
        });
      }}
      validationSchema={EGInputsSchema}
    >
      {(props) => {
        return (
          <>
            <div className={formStyles['form-container']}>
              <ListenToFormikValues
                callBackFunc={(values) => {
                  setPersonaSocialInput(values as PersonaSocialInput);
                  setCanKeepGoing(false);
                }}
              />
              <div className={styles['toggle']}>
                <div>
                  <ToggleInput
                    id="manualToggle"
                    disabled={false}
                    isChecked={true}
                    onClick={() => {
                      router.push('/editor/content?formType=social%20post');
                    }}
                  />
                </div>
                <div className={styles['toggle-name']}>
                  <b>Persona Mode</b>
                </div>
              </div>

              <div className={styles['create-button2']}>
                <div>
                  {showBrandPopup && (
                    <BasicPopup id="persona-popup">
                      <div className={styles['popup-container']}>
                        <div className={styles['popup-header-container']}>
                          <h3>Brand Persona Creation</h3>
                          <button onClick={() => setShowBrandPopup(false)}>
                            <Image
                              src="/icons/CloseBlack.svg"
                              alt="Close"
                              layout="fixed"
                              objectFit="contain"
                              height={24}
                              width={24}
                            />
                          </button>
                        </div>
                        <div className={styles['inner']}>
                          {<BrandPersonaSoloPopup onClose={closeBrand} />}
                        </div>
                      </div>
                    </BasicPopup>
                  )}
                </div>
                {showEditPopup && (
                  <BasicPopup id="persona-popup">
                    <div className={styles['popup-container']}>
                      <div className={styles['popup-header-container']}>
                        <h3>Brand Persona Creation</h3>
                        <button onClick={() => setEditPopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['inner']}>
                        {
                          <EditBrandPersonaPopup
                            brand={v1}
                            tone={v4}
                            industry={v5}
                            profilePic={v3}
                            id={id}
                            website={v6}
                            description={v7}
                            brandPositioning={v8}
                            brandNoNoWords={v9}
                            brandReplacementWords={v10}
                            brandUseSparinglyWords={v11}
                            onClose={closeEditBrand}
                          />
                        }
                      </div>
                    </div>
                  </BasicPopup>
                )}
                {showDeletePopup && (
                  <BasicPopup id="persona-popup">
                    <div className={styles['popup-container']}>
                      <div className={styles['popup-header-container']}>
                        <button onClick={() => setDeletePopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['center']}>
                        <div>
                          <div
                            className={styles['DeleteText']}
                            style={{ textAlign: 'center' }}
                          >
                            <b>
                              Are you sure you want to remove this brand persona?
                              <br />
                              <span
                                style={{
                                  display: 'block',
                                  fontWeight: 'normal',
                                  marginTop: '3px',
                                }}
                              >
                                This action is <strong>permanent</strong>.
                              </span>
                              <span
                                style={{
                                  display: 'block',
                                  fontWeight: 'normal',
                                  marginTop: '3px',
                                }}
                              >
                                Your team will lose access to this persona.
                              </span>
                              <span
                                style={{
                                  display: 'block',
                                  fontWeight: 'normal',
                                  marginTop: '3px',
                                }}
                              >
                                All linked audience personas will be deleted.
                              </span>
                            </b>
                          </div>
                          <div className={styles['DeleteButtons']}>
                            <BasicButton
                              theme="dark"
                              type="button"
                              loading={loading}
                              disabled={false}
                              text="Cancel"
                              onClick={() => {
                                setDeletePopup(!showDeletePopup);
                              }}
                              extraStyles={{
                                scale: '100%',
                              }}
                            />{' '}
                            <span>&nbsp;</span> <span>&nbsp;</span>
                            <BasicButton
                              theme="red"
                              type="button"
                              loading={loading}
                              disabled={false}
                              text="Delete"
                              image={{
                                src: '/icons/DeleteWhite.svg',
                                height: 16,
                                width: 16,
                              }}
                              onClick={async () => {
                                await deleteBrand({ id });
                                setDeletePopup(!showDeletePopup);
                              }}
                              extraStyles={{
                                scale: '100%',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </BasicPopup>
                )}
                {showProEditPopup && (
                  <BasicPopup id="persona-popup">
                    <div className={styles['popup-container']}>
                      <div className={styles['popup-header-container']}>
                        <h3>Product Persona Creation</h3>
                        <button onClick={() => setProEditPopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['inner']}>
                        {
                          <EditProductPersonaPopup
                            brand={p4}
                            id={p3}
                            product={p1}
                            description={p2}
                            onClose={closeEditProduct}
                          />
                        }
                      </div>
                    </div>
                  </BasicPopup>
                )}
                {showProDeletePopup && (
                  <BasicPopup id="persona-popup">
                    <div className={styles['popup-container']}>
                      <div className={styles['popup-header-container']}>
                        <button onClick={() => setProDeletePopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['center']}>
                        <div>
                          <div className={styles['DeleteText']}>
                            <b>Are you sure you want to delete this persona?</b>
                          </div>
                          <div className={styles['DeleteButtons']}>
                            <BasicButton
                              theme="dark"
                              type="button"
                              loading={loading}
                              disabled={false}
                              text="Cancel"
                              onClick={() => {
                                setProDeletePopup(!showProDeletePopup);
                              }}
                              extraStyles={{
                                scale: '100%',
                              }}
                            />{' '}
                            <span>&nbsp;</span> <span>&nbsp;</span>
                            <BasicButton
                              theme="red"
                              type="button"
                              loading={loading}
                              disabled={false}
                              text="Delete"
                              image={{
                                src: '/icons/DeleteWhite.svg',
                                height: 16,
                                width: 16,
                              }}
                              onClick={async () => {
                                const id = p3;
                                await deleteProduct({ id });
                                setProDeletePopup(!showProDeletePopup);
                              }}
                              extraStyles={{
                                scale: '100%',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </BasicPopup>
                )}
                {showAudEditPopup && (
                  <BasicPopup id="persona-popup">
                    <div className={styles['popup-container']}>
                      <div className={styles['popup-header-container']}>
                        <h3>Audience Persona Creation</h3>
                        <button onClick={() => setAudEditPopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['inner']}>
                        {
                          <EditAudiencePersonaPopup
                            brand={a2}
                            id={a8}
                            audience={a1}
                            age={a4}
                            occupation={a5}
                            location={a6}
                            painpoints={a7}
                            gender={a3}
                            goals={a9}
                            barriers={a10}
                            triggers={a11}
                            profilePic={a12}
                            onClose={closeEditAudience}
                          />
                        }
                      </div>
                    </div>
                  </BasicPopup>
                )}
                {showAudDeletePopup && (
                  <BasicPopup id="persona-popup">
                    <div className={styles['popup-container']}>
                      <div className={styles['popup-header-container']}>
                        <button onClick={() => setAudDeletePopup(false)}>
                          <Image
                            src="/icons/CloseBlack.svg"
                            alt="Close"
                            layout="fixed"
                            objectFit="contain"
                            height={24}
                            width={24}
                          />
                        </button>
                      </div>
                      <div className={styles['center']}>
                        <div>
                          <div className={styles['DeleteText']}>
                            <b>Are you sure you want to delete this persona?</b>
                          </div>
                          <div className={styles['DeleteButtons']}>
                            <BasicButton
                              theme="dark"
                              type="button"
                              loading={loading}
                              disabled={false}
                              text="Cancel"
                              onClick={() => {
                                setAudDeletePopup(!showAudDeletePopup);
                              }}
                              extraStyles={{
                                scale: '100%',
                              }}
                            />{' '}
                            <span>&nbsp;</span> <span>&nbsp;</span>
                            <BasicButton
                              theme="red"
                              type="button"
                              loading={loading}
                              disabled={false}
                              text="Delete"
                              image={{
                                src: '/icons/DeleteWhite.svg',
                                height: 16,
                                width: 16,
                              }}
                              onClick={async () => {
                                const id = a8;
                                await deleteAudience({ id });
                                setAudDeletePopup(!showAudDeletePopup);
                              }}
                              extraStyles={{
                                scale: '100%',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </BasicPopup>
                )}
                <h2>Social Platform</h2>
                <div>
                  <DropDownContainer>
                    <DropDownHeader onClick={toggling4}>
                      <Image
                        src={
                          socialPicture ? socialPicture : '/icons/Instagram.svg'
                        }
                        alt="Close"
                        layout="fixed"
                        objectFit="contain"
                        height={24}
                        width={24}
                      />{' '}
                      <span>&nbsp;</span>
                      <Innertext2>
                        {socialName ? socialName : 'Please select a platform'}
                      </Innertext2>
                      <DropDownIcon>
                        <Image
                          src={'/icons/Arrow Chevron Down.svg'}
                          alt="Close"
                          layout="fixed"
                          objectFit="contain"
                          height={24}
                          width={24}
                        />
                      </DropDownIcon>
                    </DropDownHeader>
                    {isOpen4 && (
                      <DropDownListContainer>
                        <DropDownList>
                          <ListItem3
                            key={'Facebook'}
                            onClick={onSocialOptionClicked(
                              SocialPlatform.FACEBOOK as SocialPlatform,
                              '/icons/Facebook.svg',
                              'Facebook'
                            )}
                            value={platformSelection as SocialPlatform}
                          >
                            <Image
                              src={'/icons/Facebook.svg'}
                              alt="Close"
                              layout="fixed"
                              objectFit="contain"
                              height={24}
                              width={24}
                            />{' '}
                            <span>&nbsp;</span>
                            Facebook
                          </ListItem3>
                          <ListItem3
                            key={'Twitter'}
                            onClick={onSocialOptionClicked(
                              SocialPlatform.TWITTER as SocialPlatform,
                              '/icons/Twitter.svg',
                              'Twitter'
                            )}
                            value={platformSelection as SocialPlatform}
                          >
                            <Image
                              src={'/icons/Twitter.svg'}
                              alt="Close"
                              layout="fixed"
                              objectFit="contain"
                              height={24}
                              width={24}
                            />{' '}
                            <span>&nbsp;</span>
                            Twitter
                          </ListItem3>
                          <ListItem3
                            key={'Instagram'}
                            onClick={onSocialOptionClicked(
                              SocialPlatform.INSTAGRAM as SocialPlatform,
                              '/icons/Instagram.svg',
                              'Instagram'
                            )}
                            value={platformSelection as SocialPlatform}
                          >
                            <Image
                              src={'/icons/Instagram.svg'}
                              alt="Close"
                              layout="fixed"
                              objectFit="contain"
                              height={24}
                              width={24}
                            />{' '}
                            <span>&nbsp;</span>
                            Instagram
                          </ListItem3>
                          <ListItem3
                            key={'LinkedIn'}
                            onClick={onSocialOptionClicked(
                              SocialPlatform.LINKEDIN as SocialPlatform,
                              '/icons/LinkedIn.svg',
                              'LinkedIn'
                            )}
                            value={platformSelection as SocialPlatform}
                          >
                            <Image
                              src={'/icons/LinkedIn.svg'}
                              alt="Close"
                              layout="fixed"
                              objectFit="contain"
                              height={24}
                              width={24}
                            />{' '}
                            <span>&nbsp;</span>
                            LinkedIn
                          </ListItem3>
                        </DropDownList>
                      </DropDownListContainer>
                    )}
                  </DropDownContainer>
                </div>
              </div>

              <div>
                {/* The Start of the DropDowns */}
                <div>
                  <h2 id="brand">Brand Persona</h2>
                </div>
                <div>
                  <DropDownContainer>
                    <DropDownHeader
                      onClick={toggling}
                      className={shouldJiggle ? styles['jiggle'] : ''}
                    >
                      <div>
                        <Image
                          src={picture ? picture : '/icons/nobrand.svg'}
                          alt="Close"
                          layout="fixed"
                          objectFit="contain"
                          height={24}
                          width={24}
                          className={styles['image2']}
                        />
                      </div>{' '}
                      <span>&nbsp;</span>
                      <Innertext>
                        {selectedOption ? selectedOption : 'Choose a Brand'}
                      </Innertext>
                      <DropDownIcon>
                        <Image
                          src={'/icons/Arrow Chevron Down.svg'}
                          alt="Close"
                          layout="fixed"
                          objectFit="contain"
                          height={24}
                          width={24}
                        />
                      </DropDownIcon>
                    </DropDownHeader>
                    {isOpen && (
                      <DropDownListContainer>
                        <DropDownList>
                          {userData?.position !== 'Content Creator' && (
                            <ListItem2
                              key={'create'}
                              onClick={() => setShowBrandPopup(!showBrandPopup)}
                            >
                              <Image
                                src={'/icons/Actions Plus.svg'}
                                alt=""
                                objectFit="contain"
                                layout="fixed"
                                width={24}
                                height={24}
                              />{' '}
                              <span>&nbsp;</span>
                              <div className={styles['left-space']}>
                                Create a Brand Persona
                              </div>
                            </ListItem2>
                          )}
                          {brandPersonas?.map((company) => (
                            <ListItem key={company.id} value={selectedBrand}>
                              <div
                                className={styles['pic-image']}
                                onClick={onOptionClicked(
                                  company.brand,
                                  company.description,
                                  company.website,
                                  company.tone,
                                  company.industry,
                                  company.profilePic,
                                  company.brandPositioning ?? '',
                                  company.brandNoNoWords ?? [''],
                                  company.brandReplacementWords ?? [
                                    { replaceThis: '', withThis: '' },
                                  ],
                                  company.brandUseSparinglyWords ?? [''],
                                    company,
                                )}
                              >
                                <Image
                                  src={
                                    company.profilePic
                                      ? company.profilePic
                                      : '/icons/nobrand.svg'
                                  }
                                  alt="Close"
                                  layout="fixed"
                                  objectFit="contain"
                                  height={24}
                                  width={24}
                                  className={styles['image2']}
                                />{' '}
                                <span>&nbsp;</span>
                                <div className={styles['left-space']}>
                                  {company.brand}
                                </div>
                              </div>
                              {((userData?.organizationOwner &&
                                company.organizationPersona) ||
                                !company.organizationPersona) &&
                                userData?.position !== 'Content Creator' && (
                                  <div className={styles['BrandEdit']}>
                                    <div
                                      className={styles['edit-button']}
                                      onClick={BrandEditClick(
                                        company.brand,
                                        company.id,
                                        company.profilePic,
                                        company.tone,
                                        company.industry,
                                        company.website,
                                        company.description,
                                        company.brandPositioning ?? '',
                                        company.brandNoNoWords ?? [''],
                                        company.brandReplacementWords ?? [
                                          { replaceThis: '', withThis: '' },
                                        ],
                                        company.brandUseSparinglyWords ?? [''],
                                      )}
                                    >
                                      <Image
                                        src={'/icons/Edit_Icon.svg'}
                                        alt="Close"
                                        layout="fixed"
                                        objectFit="contain"
                                        height={14}
                                        width={14}
                                      />
                                    </div>{' '}
                                    <span>&nbsp;</span>
                                    <div
                                      className={styles['delete-button']}
                                      onClick={BrandDeleteClick(
                                        company.brand,
                                        company.id,
                                        company.profilePic,
                                        company.tone,
                                        company.industry,
                                        company.website,
                                        company.description,
                                        company.brandPositioning ?? ''
                                      )}
                                    >
                                      <Image
                                        src={'/icons/Delete.svg'}
                                        alt="Close"
                                        layout="fixed"
                                        objectFit="contain"
                                        height={14}
                                        width={14}
                                      />
                                    </div>
                                  </div>
                                )}
                            </ListItem>
                          ))}
                        </DropDownList>
                      </DropDownListContainer>
                    )}
                  </DropDownContainer>
                </div>
              </div>

              {/*Product DropDown*/}

              <div>
                <div className={styles['create-button']}>
                  <div>
                    <h2>Product Persona</h2>
                  </div>
                  <div>
                    {showProductPopup && (
                      <BasicPopup id="persona-popup">
                        <div className={styles['popup-container']}>
                          <div className={styles['popup-header-container']}>
                            <h3>Product Persona Creation</h3>
                            <button onClick={() => setShowProductPopup(false)}>
                              <Image
                                src="/icons/CloseBlack.svg"
                                alt="Close"
                                layout="fixed"
                                objectFit="contain"
                                height={24}
                                width={24}
                              />
                            </button>
                          </div>
                          <div className={styles['inner']}>
                            {<ProductPersonaSoloPopup onClose={closeProduct} />}
                          </div>
                        </div>
                      </BasicPopup>
                    )}
                  </div>
                </div>
                <div>
                  <DropDownContainer2>
                    <DropDownHeader
                      onClick={toggling3}
                      className={B1 !== '' ? '' : styles['gray']}
                    >
                      <Innertext2>
                        {selectedProOption
                          ? selectedProOption
                          : 'Choose a Product'}
                      </Innertext2>
                      <DropDownIcon2>
                        <Image
                          src={'/icons/Arrow Chevron Down.svg'}
                          alt="Close"
                          layout="fixed"
                          objectFit="contain"
                          height={24}
                          width={24}
                        />
                      </DropDownIcon2>
                    </DropDownHeader>
                    {isOpen3 && (
                      <DropDownListContainer>
                        <DropDownList>
                          {userData?.position !== 'Content Creator' && (
                            <ListItem2
                              key={'create'}
                              onClick={() =>
                                setShowProductPopup(!showProductPopup)
                              }
                            >
                              <Image
                                src={'/icons/Actions Plus.svg'}
                                alt=""
                                objectFit="contain"
                                layout="fixed"
                                width={24}
                                height={24}
                              />{' '}
                              <span>&nbsp;</span>
                              <div>Create a Product Persona</div>
                            </ListItem2>
                          )}
                          <ListItem2
                            key={'nothing'}
                            onClick={onProOptionClicked('Optional', '')}
                            value={selectedProduct}
                          >
                            <div>Optional</div>
                          </ListItem2>
                          {productPersonas?.map((company) => (
                            <ListItem key={company.id} value={selectedProduct}>
                              <div
                                className={styles['pic-image']}
                                onClick={onProOptionClicked(
                                  company.product,
                                  company.description
                                )}
                              >
                                {company.product}
                              </div>
                              {((userData?.organizationOwner &&
                                company.organizationPersona) ||
                                !company.organizationPersona) &&
                                userData?.position !== 'Content Creator' && (
                                  <div className={styles['BrandEdit']}>
                                    <div
                                      className={styles['edit-button']}
                                      onClick={ProductEditClick(
                                        company.product,
                                        company.description,
                                        company.id,
                                        company.brand
                                      )}
                                    >
                                      <Image
                                        src={'/icons/Edit_Icon.svg'}
                                        alt="Close"
                                        layout="fixed"
                                        objectFit="contain"
                                        height={14}
                                        width={14}
                                      />
                                    </div>{' '}
                                    <span>&nbsp;</span>
                                    <div
                                      className={styles['delete-button']}
                                      onClick={ProductDeleteClick(
                                        company.product,
                                        company.description,
                                        company.id,
                                        company.brand
                                      )}
                                    >
                                      <Image
                                        src={'/icons/Delete.svg'}
                                        alt="Close"
                                        layout="fixed"
                                        objectFit="contain"
                                        height={14}
                                        width={14}
                                      />
                                    </div>
                                  </div>
                                )}
                            </ListItem>
                          ))}
                        </DropDownList>
                      </DropDownListContainer>
                    )}
                  </DropDownContainer2>
                </div>
              </div>

              {/* Aduience Dropdown */}

              <div>
                <div className={styles['create-button']}>
                  <div>
                    <h2 id="aud">Audience Persona</h2>
                  </div>
                  <div>
                    {showAudiencePopup && (
                      <BasicPopup id="persona-popup">
                        <div className={styles['popup-container']}>
                          <div className={styles['popup-header-container']}>
                            <h3>Audience Persona Creation</h3>
                            <button onClick={() => setShowAudiencePopup(false)}>
                              <Image
                                src="/icons/CloseBlack.svg"
                                alt="Close"
                                layout="fixed"
                                objectFit="contain"
                                height={24}
                                width={24}
                              />
                            </button>
                          </div>
                          <div className={styles['inner']}>
                            {
                              <AudiencePersonaSoloPopup
                                onClose={closeAudience}
                              />
                            }
                          </div>
                        </div>
                      </BasicPopup>
                    )}
                  </div>
                </div>
                <div>
                  <DropDownContainer3>
                    <DropDownHeader
                      onClick={toggling2}
                      className={B1 !== '' ? '' : styles['gray']}
                    >
                      <div>
                        <Image
                          src={picture2 ? picture2 : '/icons/nobrand.svg'}
                          alt="Close"
                          layout="fixed"
                          objectFit="contain"
                          height={24}
                          width={24}
                          className={styles['image2']}
                        />
                      </div>{' '}
                      <span>&nbsp;</span>
                      <Innertext>
                        {selectedAudOption
                          ? selectedAudOption
                          : 'Choose an Audience'}
                      </Innertext>
                      <DropDownIcon3>
                        <Image
                          src={'/icons/Arrow Chevron Down.svg'}
                          alt="Close"
                          layout="fixed"
                          objectFit="contain"
                          height={24}
                          width={24}
                          className={B1 !== '' ? '' : styles['opac']}
                        />
                      </DropDownIcon3>
                    </DropDownHeader>
                    {isOpen2 && (
                      <DropDownListContainer>
                        <DropDownList>
                          {userData?.position !== 'Content Creator' && (
                            <ListItem2
                              key={'create'}
                              onClick={() =>
                                setShowAudiencePopup(!showAudiencePopup)
                              }
                            >
                              <Image
                                src={'/icons/Actions Plus.svg'}
                                alt=""
                                objectFit="contain"
                                layout="fixed"
                                width={24}
                                height={24}
                              />{' '}
                              <span>&nbsp;</span>
                              <div>Create an Audience Persona</div>
                            </ListItem2>
                          )}
                          {brandSelectedContent?.map((company) => (
                            <ListItem key={company.id} value={selectedAudience}>
                              <div
                                className={styles['pic-image']}
                                onClick={onAudOptionClicked(
                                  company.audience,
                                  company.painpoints,
                                  company.location,
                                  company.occupation,
                                  company.age,
                                  company.goals ?? '',
                                  company.barriers ?? '',
                                  company.triggers ?? '',
                                  company.profilePic ?? '',
                                  company,
                                )}
                              >
                                <Image
                                  src={
                                    company.profilePic
                                      ? company.profilePic
                                      : '/icons/nobrand.svg'
                                  }
                                  alt="Close"
                                  layout="fixed"
                                  objectFit="contain"
                                  height={24}
                                  width={24}
                                  className={styles['image2']}
                                />{' '}
                                <span>&nbsp;</span>
                                <div className={styles['left-space']}>
                                  {company.audience}
                                </div>
                              </div>
                              {((userData?.organizationOwner &&
                                company.organizationPersona) ||
                                !company.organizationPersona) &&
                                userData?.position !== 'Content Creator' && (
                                  <div className={styles['BrandEdit']}>
                                    <div
                                      className={styles['edit-button']}
                                      onClick={AudienceEditClick(
                                        company.audience,
                                        company.brand,
                                        company.gender,
                                        company.age,
                                        company.occupation,
                                        company.location,
                                        company.painpoints,
                                        company.id,
                                        company.goals ?? '',
                                        company.barriers ?? '',
                                        company.triggers ?? '',
                                        company.profilePic ?? ''
                                      )}
                                    >
                                      <Image
                                        src={'/icons/Edit_Icon.svg'}
                                        alt="Close"
                                        layout="fixed"
                                        objectFit="contain"
                                        height={14}
                                        width={14}
                                      />
                                    </div>{' '}
                                    <span>&nbsp;</span>
                                    <div
                                      className={styles['delete-button']}
                                      onClick={AudienceDeleteClick(
                                        company.audience,
                                        company.brand,
                                        company.gender,
                                        company.age,
                                        company.occupation,
                                        company.location,
                                        company.painpoints,
                                        company.id,
                                        company.goals ?? '',
                                        company.barriers ?? '',
                                        company.triggers ?? '',
                                        company.profilePic ?? ''
                                      )}
                                    >
                                      <Image
                                        src={'/icons/Delete.svg'}
                                        alt="Close"
                                        layout="fixed"
                                        objectFit="contain"
                                        height={14}
                                        width={14}
                                      />
                                    </div>
                                  </div>
                                )}
                            </ListItem>
                          ))}
                        </DropDownList>
                      </DropDownListContainer>
                    )}
                  </DropDownContainer3>
                </div>
              </div>

              <div>
                <div>
                  <h2>Goal</h2>
                </div>

                <BoxedAutoResizeTextarea
                  id="textarea"
                  placeholder="ex. Celebrate how much time you've saved by using SuperCopy."
                  value={props.values.intent}
                  setValue={props.handleChange('intent')}
                  disabled={loading}
                  errors={props.errors.intent as string}
                  touched={props.touched.intent ? true : false}
                  onBlur={props.handleBlur}
                />
              </div>
              <div>
                <AdvancedInputs formikProps={props} disabled={loading} />
              </div>
            </div>
            <GenerateResponseButtons onSubmit={() => props.handleSubmit()} />
          </>
        );
      }}
    </Formik>
  );
};
